export const COMPLIANCE_KEY = 'qlCompliance'